"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Selectors {
    /**
     * Create data role selector. Based on the first character of the role, use specific matching-pattern
     *
     * Example:  data-role="top-flower flower top topper"
     *
     * - '~flower' matches [flower]                (word boundary only)
     * - '|top' matches [top-flower, top]          (starts with, hyphen separated)
     * - '^top' matches [top, topper]              (starts with, any)
     * - '$flower' matches [top-flower, flower]    (ends with)
     * - '*er' matches [top-flower flower topper]  (contains)
     */
    static createDataRoleSelector(role) {
        if (role === undefined || role === '') {
            return undefined;
        }
        let glue = '=';
        switch (role.charAt(0)) {
            case '~':
            case '^':
            case '$':
            case '*':
            case '|':
                glue = role.charAt(0) + glue;
                role = role.substr(1);
                break;
            default:
                glue = '~' + glue;
                break;
        }
        return '[data-role' + glue + '"' + role + '"]';
    }
}
exports.default = Selectors;
//# sourceMappingURL=Selectors.js.map